@if (playerProfile) {
  <div class="flex align-items-center gap-2">
    <div class="flex align-items-center gap-1">
      @if (paidToDate) {
        <span class="green font-bold"
              [pTooltip]="'PLAYER_PROFILE_PRO_TOOLTIP' | translate: {value: (paidToDate | date: 'mediumDate')}"
              [showDelay]="400">
          {{ 'PLAYER_PROFILE_PRO' | translate }}
        </span>
        <!--<i class="pi pi-face-smile green text-sm"></i>-->
        @if (longStatus) {
          <span>({{ 'TO_VALUE' | translate:  {value: (paidToDate | date: 'mediumDate')} }})</span>
        }
      } @else if (paidToDateExpired) {
        <span class="text-orange-frontend font-bold"
              [pTooltip]="'PLAYER_PROFILE_BASIC_TOOLTIP' | translate" [showDelay]="400">
          {{ 'PLAYER_PROFILE_BASIC' | translate }}
        </span>
        @if (longStatus) {
          <span>({{ 'PLAYER_PROFILE_PRO_EXPIRED' | translate }})</span>
        }
      } @else {
        <span class="text-orange-frontend font-bold" [pTooltip]="'PLAYER_PROFILE_BASIC_TOOLTIP' | translate" [showDelay]="400">
          {{ 'PLAYER_PROFILE_BASIC' | translate }}
        </span>
      }
    </div>

    @if (buttonGotoPayment && showPurchase) {
      <p-button icon="pi pi-shopping-cart" styleClass="p-button-text no-padding"
                [label]="'BUY_PRO_ACCOUNT' | translate"
                routerLink="/frontend/player/profile/account/payments"/>
    }
  </div>
}
